import { BroadcastAffiliationList as BroadcastAffiliationListComponent } from './BroadcastAffiliationList.component';
import { connector } from './BroadcastAffiliationList.connector';

export const BroadcastAffiliationList = connector(BroadcastAffiliationListComponent);
